import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDetonationArrestor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 19,
	viewBox: "0 0 50.0 19.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 2,
		width: 50,
		height: 15,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 0,
		width: 40,
		height: 19,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgDetonationArrestor;
